// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { previousDay as fn } from "../previousDay.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const previousDay = convertToFP(fn, 2);

// Fallback for modularized imports:
export default previousDay;
